module.exports = __webpack_public_path__ + "img/logo-main.282427a5.svg";